import React from 'react';
import './HeaderButtonWrapper.scss';

export const HeaderButtonWrapper: React.FC = ({ children }) => (
  <div className="header-button-wrapper">{children}</div>
);
